import { logError } from "~/lib/logger";
import type { ErrorResponse } from "~/types";

/**
 * Handles the error response from the API
 * @param error - The error response from the API
 * @param message - The message to log
 * @param location - The location where the error occurred
 * @returns The error response object
 */
export const handleError = (
  error: any,
  message: string,
  location: string
): ErrorResponse => {
  if (error.errors) {
    // Handle nested errors
    const nestedErrors =
      error.errors[0]?.data?.[0]?.errors || error.errors[0]?.errors;

    logError("payloadApiCollections", message, {
      errors: nestedErrors,
      function: location,
    });

    return {
      success: false,
      message: nestedErrors?.[0]?.message || "An unknown error occurred",
    };
  } else if (error.message) {
    logError("payloadApiCollections", message, {
      error: error.message,
      function: location,
    });

    // Handle other errors with a message property
    return {
      success: false,
      message: error.message,
    };
  } else {
    // Handle unknown errors
    logError("payloadApiCollections", message, {
      error: "An unknown error occurred",
      function: location,
    });

    return {
      success: false,
      message: "An unknown error occurred",
    };
  }
};
